import makeStyles from '@material-ui/core/styles/makeStyles';
import React from 'react';
import { useObservable } from 'react-use-observable';
import eduzzAccountsService from 'v2/services/eduzzAccount';

import type { Placement } from 'react-joyride';

const useStyles = makeStyles((theme) => ({
  eduzzinho: {
    ['&:after' as any]: {
      content: '""',
      backgroundImage: 'url(/img/mascote_edu_apresentando.png)',
      backgroundSize: 'cover',
      width: 170,
      height: 280,
      position: 'absolute',
      right: -130,
      top: 0,
      zIndex: 5,
      backgroundPosition: 'center',
      [theme.breakpoints.down('sm')]: {
        display: 'none',
      },
    },
  },
  hello: {
    fontSize: 20,
  },
}));

const WelcomeMessage = () => {
  const classes = useStyles();
  const [user] = useObservable(() => eduzzAccountsService.getUser(), []);
  return (
    <>
      <>
        <b className={classes.hello}>Olá {user?.name || ''}!</b> Você está no Órbita, a nova plataforma da Eduzz para gerir seu negócio online. Vem
        com a gente nesse tour para descobrir as principais funcionalidades que preparamos para você
      </>
      <div className={classes.eduzzinho} />
    </>
  );
};
export const steps = [
  {
    target: 'body',
    content: <WelcomeMessage />,
    placement: 'center' as Placement,
  },
  {
    target: '#myNotifications',
    content: 'Notificações de afiliação, mensagens e outros avisos importantes estão aqui',
  },
  {
    target: '#myProfile',
    content:
      'Aqui você encontra seu Perfil, nesse menu é possível alterar seus dados cadastrais, consultar suas compras e alterar suas formas de pagamento',
  },
];
